module.exports = __webpack_public_path__ + "img/2x.fa9718c.jpg";